import React from 'react'
import { Outlet } from 'react-router-dom'
import AdminProtectedRoute from '@/components/auth/AdminProtectedRoute'
import AdminHeader from '@/components/admin/AdminHeader'

export default function AdminLayout() {
  return (
    <AdminProtectedRoute>
      <div className="admin-app">
        <AdminHeader />
        <div className="px-6 py-6 space-y-8 max-w-[1400px] mx-auto w-full">
          <Outlet />
        </div>
      </div>
    </AdminProtectedRoute>
  )
}
